export { default } from './AirBnBFeaturedDestinationsContainer';
